import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BusinesscoItem, BusinessItem, CoopItem, CountryItem, DeliveryMethodItem, DeliveryTermItem, DepartmentItem, StockplaceItem } from '@app/services/logistic.service';
import { OrderHeadGet, OrderheadService, OrderMethodItem, PortalUserItem, SellerItem } from '@app/services/orderhead.service';
import { CustomerPersonItem, FactoringItem, InvoiceMethodsItem, PaymentTypeItem, PriceListItem, TaxItem, ValutaItem } from '@app/services/economy.service';
import { Subject, takeUntil } from 'rxjs';
import { PickJobGroupItem } from '@app/services/pick-job-group.service';
import { CollectionItem } from '@app/services/collection.service';
import { SpecialDiscount2Item } from '@app/services/discount-group.service';
import { ModalService } from '@app/core/services/modal.service';
import { OrderHeadContextService } from '../order-head-context.service';

@Component({
    selector: 'tt-order-head-edit',
    templateUrl: './order-head-edit.component.html',
    styleUrls: ['./order-head-edit.component.css'],
})
export class OrderHeadEditComponent implements OnDestroy {
    @Output()
    public saved = new EventEmitter<void>();

    @Input()
    public set get(value: OrderHeadGet | undefined) {
        this._get = value;

        if (!!value) {
            this.customerForm.reset(
                {
                    contact_pers_no: value.contact_pers_no,
                    customers_orderno: value.customers_orderno,
                    customers_ref1: value.customers_ref1,
                    customers_ref2: value.customers_ref2,
                    label: value.label,
                    message_from_sales: value.message_from_sales,
                    message_to_supplier: value.message_to_supplier,
                    project_keyno: value.project_keyno,
                    project_name: value.project_name,
                    serviceobject_keyno: value.serviceobject_keyno,
                    serviceobject_name: value.serviceobject_name,
                    stat_business_id: value.stat_business_id,
                    stat_coop_id: value.stat_coop_id,
                    stat_cust_address: value.stat_cust_address,
                    stat_cust_name: value.stat_cust_name,
                    stat_cust_no: '' + value.stat_cust_no,
                    svea_payment_uri: value.svea_payment_uri,
                },
                { emitEvent: false },
            );

            this.deliveryForm.reset(
                {
                    deladronpurch: value.deladronpurch,
                    delivery_adr_mail: value.delivery_adr_mail,
                    delivery_adr_note: value.delivery_adr_note,
                    delivery_adr_street: value.delivery_adr_street,
                    delivery_business_id: value.delivery_business_id,
                    delivery_coop_id: value.delivery_coop_id,
                    delivery_country_id: value.delivery_country_id,
                    delivery_cust_address: value.delivery_cust_address,
                    delivery_cust_name: value.delivery_cust_name,
                    delivery_cust_no: value.delivery_cust_no,
                    delivery_cust_phone: value.delivery_cust_phone,
                    delivery_cust_unreg: value.delivery_cust_unreg,
                    delivery_email: value.delivery_email,
                    delivery_place: value.delivery_place,
                    delivery_postplace_name: value.delivery_postplace_name,
                    delivery_postplace_name_street: value.delivery_postplace_name_street,
                    delivery_postplace_id: value.delivery_postplace_id,
                    delivery_postplace_id_and_name: value.delivery_postplace_id_and_name,
                    delivery_postplace_id_and_name_street: value.delivery_postplace_id_and_name_street,
                    delivery_postplace_id_street: value.delivery_postplace_id_street,
                    deliverydate_confirmed: value.deliverydate_confirmed,
                    deliverydate_text: value.deliverydate_text,
                    deliverydate_wish: value.deliverydate_wish,
                    deliverymethod_no: value.deliverymethod_no,
                    deliverytime_confirmed: value.deliverytime_confirmed,
                    offer_sent: value.offer_sent,
                    offer_valid_to_date: value.offer_valid_to_date,
                    partly_delivery_allowed: value.partly_delivery_allowed,
                    pickjobgrp_keyno: value.pickjobgrp_keyno,
                    printed_orderconfirm: value.printed_orderconfirm,
                },
                { emitEvent: false },
            );

            this.infoForm.reset(
                {
                    businessco_no: value.businessco_no,
                    reg_by_portal_user_keyno: value.reg_by_portal_user_keyno,
                    ordertype_name: value.ordertype_name,
                    order_date: value.order_date,
                    verified: value.verified,
                    order_order_no: value.order_order_no,
                    orderstatus_name: value.orderstatus_name,
                    order_offer_no: value.order_offer_no,
                    ordermethod_id: value.ordermethod_id,
                    stockplace_id: value.stockplace_id,
                    seller_no: value.seller_no,
                    purch_internal_no_from: value.purch_internal_no_from,
                    consernorder_order_no: value.consernorder_order_no,
                    department_id: value.department_id,
                    orderhead_note1: value.orderhead_note1,
                    orderhead_note2: value.orderhead_note2,
                    orderhead_note3: value.orderhead_note3,
                },
                { emitEvent: false },
            );

            this.invoiceForm.reset(
                {
                    carriers_paid_by_customer: value.carriers_paid_by_customer,
                    collection_keyno: value.collection_keyno,
                    custbonusdeal: value.custbonusdeal,
                    deliveryterm_no: value.deliveryterm_no,
                    factoring_no: value.factoring_no,
                    freight_cost_ordval: value.freight_cost_ordval,
                    freight_cost_ordval_agreed: value.freight_cost_ordval_agreed,
                    freight_paid_by: value.freight_paid_by,
                    invoice_business_id: value.invoice_business_id,
                    invoice_coop_id: value.invoice_coop_id,
                    invoice_country_id: value.invoice_country_id,
                    invoice_cust_address: value.invoice_cust_address,
                    invoice_cust_name: value.invoice_cust_name,
                    invoice_cust_no: value.invoice_cust_no,
                    invoice_valuta_id: value.invoice_valuta_id,
                    invoicemethod_no: value.invoicemethod_no,
                    order_valuta_id: value.order_valuta_id,
                    payment_id: value.payment_id,
                    pricelist_id: value.pricelist_id,
                    pricelist_id2: value.pricelist_id2,
                    purchase_pricelist_id: value.purchase_pricelist_id,
                    purchase_pricelist_id2: value.purchase_pricelist_id2,
                    special_discount2_keyno: value.special_discount2_keyno,
                    tax_keyno: value.tax_keyno,
                },
                { emitEvent: false },
            );

            this.context.setOrderHead(value);
            this.refreshOrderStatusName(value);
        }
    }
    public get get(): OrderHeadGet | undefined {
        return this._get;
    }
    private _get?: OrderHeadGet;

    public get hasUnsavedChanges(): boolean {
        return this.orderHeadForm.dirty || this.get?.data_changed_in_get === '1';
    }

    public get showButtonCard(): boolean {
        return this.hasUnsavedChanges || (!!this.get && this.get.orderconfirm_reportdef_keyno > '') || (!!this.get && this.get.delivered === '0');
    }

    public readonly customerForm = new FormGroup<OrderHeadCustomerFormGroup>({
        stat_cust_no: new FormControl('', { nonNullable: true }),
        stat_cust_name: new FormControl('', { nonNullable: true }),
        stat_cust_address: new FormControl('', { nonNullable: true }),
        contact_pers_no: new FormControl('', { nonNullable: true }),
        customers_orderno: new FormControl('', { nonNullable: true }),
        svea_payment_uri: new FormControl('', { nonNullable: true }),
        project_keyno: new FormControl('', { nonNullable: true }),
        project_name: new FormControl('', { nonNullable: true }),
        serviceobject_keyno: new FormControl('', { nonNullable: true }),
        serviceobject_name: new FormControl('', { nonNullable: true }),
        customers_ref1: new FormControl('', { nonNullable: true }),
        customers_ref2: new FormControl('', { nonNullable: true }),
        message_from_sales: new FormControl('', { nonNullable: true }),
        message_to_supplier: new FormControl('', { nonNullable: true }),
        label: new FormControl('', { nonNullable: true }),
        stat_business_id: new FormControl('', { nonNullable: true }),
        stat_coop_id: new FormControl('', { nonNullable: true }),
    });

    public readonly deliveryForm = new FormGroup<OrderHeadDeliveryFormGroup>({
        delivery_cust_unreg: new FormControl('', { nonNullable: true }),
        delivery_cust_no: new FormControl('', { nonNullable: true }),
        delivery_cust_name: new FormControl('', { nonNullable: true }),
        delivery_cust_address: new FormControl('', { nonNullable: true }),
        delivery_adr_street: new FormControl('', { nonNullable: true }),
        delivery_postplace_id_street: new FormControl('', { nonNullable: true }),
        delivery_postplace_id_and_name_street: new FormControl('', { nonNullable: true }),
        delivery_adr_mail: new FormControl('', { nonNullable: true }),
        delivery_postplace_name: new FormControl('', { nonNullable: true }),
        delivery_postplace_name_street: new FormControl('', { nonNullable: true }),
        delivery_postplace_id: new FormControl('', { nonNullable: true }),
        delivery_postplace_id_and_name: new FormControl('', { nonNullable: true }),
        delivery_country_id: new FormControl('', { nonNullable: true }),
        delivery_place: new FormControl('', { nonNullable: true }),
        delivery_cust_phone: new FormControl('', { nonNullable: true }),
        delivery_email: new FormControl('', { nonNullable: true }),
        deladronpurch: new FormControl('', { nonNullable: true }),
        delivery_adr_note: new FormControl('', { nonNullable: true }),
        delivery_business_id: new FormControl('', { nonNullable: true }),
        delivery_coop_id: new FormControl('', { nonNullable: true }),
        offer_valid_to_date: new FormControl('', { nonNullable: true }),
        offer_sent: new FormControl('', { nonNullable: true }),
        deliverydate_wish: new FormControl('', { nonNullable: true }),
        deliverydate_text: new FormControl('', { nonNullable: true }),
        deliverydate_confirmed: new FormControl('', { nonNullable: true }),
        deliverytime_confirmed: new FormControl('', { nonNullable: true }),
        deliverymethod_no: new FormControl('', { nonNullable: true }),
        pickjobgrp_keyno: new FormControl('', { nonNullable: true }),
        partly_delivery_allowed: new FormControl('', { nonNullable: true }),
        printed_orderconfirm: new FormControl('', { nonNullable: true }),
    });

    public readonly invoiceForm = new FormGroup<OrderHeadInvoiceFormGroup>({
        invoice_cust_no: new FormControl('', { nonNullable: true }),
        invoice_cust_name: new FormControl('', { nonNullable: true }),
        invoice_cust_address: new FormControl('', { nonNullable: true }),
        invoice_country_id: new FormControl('', { nonNullable: true }),
        invoice_business_id: new FormControl('', { nonNullable: true }),
        invoice_coop_id: new FormControl('', { nonNullable: true }),
        carriers_paid_by_customer: new FormControl('', { nonNullable: true }),
        collection_keyno: new FormControl('', { nonNullable: true }),
        custbonusdeal: new FormControl('', { nonNullable: true }),
        deliveryterm_no: new FormControl('', { nonNullable: true }),
        factoring_no: new FormControl('', { nonNullable: true }),
        freight_cost_ordval: new FormControl('', { nonNullable: true }),
        freight_cost_ordval_agreed: new FormControl('', { nonNullable: true }),
        freight_paid_by: new FormControl('', { nonNullable: true }),
        invoice_valuta_id: new FormControl('', { nonNullable: true }),
        invoicemethod_no: new FormControl('', { nonNullable: true }),
        order_valuta_id: new FormControl('', { nonNullable: true }),
        payment_id: new FormControl('', { nonNullable: true }),
        pricelist_id: new FormControl('', { nonNullable: true }),
        pricelist_id2: new FormControl('', { nonNullable: true }),
        purchase_pricelist_id: new FormControl('', { nonNullable: true }),
        purchase_pricelist_id2: new FormControl('', { nonNullable: true }),
        special_discount2_keyno: new FormControl('', { nonNullable: true }),
        tax_keyno: new FormControl('', { nonNullable: true }),
    });

    public readonly infoForm = new FormGroup({
        businessco_no: new FormControl('', { nonNullable: true }),
        reg_by_portal_user_keyno: new FormControl('', { nonNullable: true }),
        ordertype_name: new FormControl('', { nonNullable: true }),
        order_date: new FormControl('', { nonNullable: true }),
        verified: new FormControl('', { nonNullable: true }),
        order_order_no: new FormControl('', { nonNullable: true }),
        orderstatus_name: new FormControl('', { nonNullable: true }),
        order_offer_no: new FormControl('', { nonNullable: true }),
        ordermethod_id: new FormControl('', { nonNullable: true }),
        stockplace_id: new FormControl('', { nonNullable: true }),
        seller_no: new FormControl('', { nonNullable: true }),
        purch_internal_no_from: new FormControl('', { nonNullable: true }),
        consernorder_order_no: new FormControl('', { nonNullable: true }),
        department_id: new FormControl('', { nonNullable: true }),
        orderhead_note1: new FormControl('', { nonNullable: true }),
        orderhead_note2: new FormControl('', { nonNullable: true }),
        orderhead_note3: new FormControl('', { nonNullable: true }),
    });

    public readonly orderHeadForm = new FormGroup({
        customer: this.customerForm,
        delivery: this.deliveryForm,
        invoice: this.invoiceForm,
        info: this.infoForm,
    });

    public companies: BusinesscoItem[] = [];

    public portalUsers: PortalUserItem[] = [];

    public orderMethods: OrderMethodItem[] = [];

    public stockplaces: StockplaceItem[] = [];

    public sellers: SellerItem[] = [];

    public departments: DepartmentItem[] = [];

    public customerPersons: CustomerPersonItem[] = [];

    public businesses: BusinessItem[] = [];

    public coops: CoopItem[] = [];

    public countries: CountryItem[] = [];

    public deliveryMethods: DeliveryMethodItem[] = [];

    public pickJobGroups: PickJobGroupItem[] = [];

    public deliveryTerms: DeliveryTermItem[] = [];

    public payments: PaymentTypeItem[] = [];

    public pricelists: PriceListItem[] = [];

    public factorings: FactoringItem[] = [];

    public invoiceMethods: InvoiceMethodsItem[] = [];

    public taxes: TaxItem[] = [];

    public valutas: ValutaItem[] = [];

    public discount2s: SpecialDiscount2Item[] = [];

    public collections: CollectionItem[] = [];

    private readonly destroy$ = new Subject<void>();

    public saving = false;

    public going = false;

    public delivering = false;

    constructor(
        private orderhead: OrderheadService,
        private modal: ModalService,
        private context: OrderHeadContextService,
    ) {
        this.bindContext();
        this.bindFormChanges();
    }

    public async save() {
        const orderHead = this.getOrderHeadFromForm();

        if (!orderHead) return;

        try {
            this.saving = true;

            const { errorcode, errormessage } = await this.orderhead.saveOrderHead(orderHead);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.saved.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    public async deliver() {
        const orderHead = this.getOrderHeadFromForm();

        if (!orderHead) return;

        try {
            this.delivering = true;
            const confirmed = await this.modal.openConfirmDialog({ type: 'danger', title: 'confirm_title', translateTitle: true, message: 'orderhead_delivery_confirmtext', translateMessage: true });

            if (!confirmed) return;

            const { errorcode, errormessage } = await this.orderhead.saveOrderHead(orderHead);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
                return;
            }

            await this.orderhead.deliverOrder(orderHead);

            this.saved.emit();
        } catch (error) {
            console.error(error);
        } finally {
            this.delivering = false;
        }
    }

    public saveWithErrorThrow = async () => {
        const orderHead = this.getOrderHeadFromForm();

        if (!orderHead) return;

        try {
            this.going = true;

            const { errorcode, errormessage } = await this.orderhead.saveOrderHead(orderHead);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
                throw Error(errormessage);
            }
        } finally {
            this.going = false;
        }
    };

    public getOrderHeadFromForm = (): OrderHeadGet | undefined => {
        const get = this.get;

        if (!get) return;

        const { customer, delivery, invoice, info } = this.orderHeadForm.getRawValue();

        return Object.assign({}, get, customer, delivery, invoice, info);
    };

    private bindContext() {
        this.context.staticData$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
                this.companies = data.companies;
                this.portalUsers = data.portalUsers;
                this.orderMethods = data.orderMethods;
                this.businesses = data.businesses;
                this.coops = data.coops;
                this.countries = data.countries;
                this.deliveryTerms = data.deliveryTerms;
                this.payments = data.payments;
                this.pricelists = data.pricelists;
                this.factorings = data.factorings;
                this.invoiceMethods = data.invoiceMethods;
                this.valutas = data.valutas;
                this.discount2s = data.discount2s;
                this.collections = data.collections;
            },
        });

        this.context.businesscoData$.pipe(takeUntil(this.destroy$)).subscribe({
            next: ({ stockplaces, sellers, departments }) => {
                this.stockplaces = stockplaces;
                this.sellers = sellers;
                this.departments = departments;
            },
        });

        this.context.customerPersons$.pipe(takeUntil(this.destroy$)).subscribe({ next: (value) => (this.customerPersons = value) });
        this.context.pickJobGroups$.pipe(takeUntil(this.destroy$)).subscribe({ next: (value) => (this.pickJobGroups = value) });
        this.context.taxes$.pipe(takeUntil(this.destroy$)).subscribe({ next: (value) => (this.taxes = value) });
        this.context.deliveryMethods$.pipe(takeUntil(this.destroy$)).subscribe({ next: (value) => (this.deliveryMethods = value) });
        this.context.deliveryMethodData$.pipe(takeUntil(this.destroy$)).subscribe({ next: (value) => this.deliveryForm.patchValue({ pickjobgrp_keyno: value.pickjobgrp_keyno }) });
    }

    private bindFormChanges() {
        this.customerForm.controls.stat_cust_no.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.customerPersons = [];
            this.context.setStatCustNo(value);
        });

        this.customerForm.controls.contact_pers_no.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.updateDeliveryContactInfo(value);
        });

        this.infoForm.controls.businessco_no.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.stockplaces = [];
            this.sellers = [];
            this.departments = [];
            this.context.setBusinesscoNo(value);
        });

        this.infoForm.controls.stockplace_id.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.pickJobGroups = [];
            this.context.setStockplaceId(value);
        });

        this.invoiceForm.controls.invoice_country_id.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.taxes = [];
            this.context.setInvoiceCountryId(value);
        });

        this.deliveryForm.controls.deliverymethod_no.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.context.setDeliveryMethodNo(value);
        });
    }

    private updateDeliveryContactInfo(contactPersonNo: string) {
        if (this.get?.setting_orderhead_use_contact_person_info_on_delivery !== '1') return;

        const customerPerson = this.customerPersons.find((item) => '' + item.item_id === '' + contactPersonNo);

        if (!customerPerson) return;

        this.deliveryForm.patchValue({
            delivery_cust_phone: customerPerson.pers_phone ?? '',
            delivery_email: customerPerson.pers_email ?? '',
        });
    }

    private async refreshOrderStatusName(get: OrderHeadGet) {
        if (get.show_oh_head_orderstatus_name === '0') return;

        try {
            const orderInternalNo = get.order_internal_no;
            const response = await this.orderhead.getOrderStatusName({ order_internal_no: orderInternalNo });

            if ('' + this.get?.order_internal_no !== '' + orderInternalNo) return;

            this.infoForm.controls.orderstatus_name.patchValue(response?.orderstatus_name ?? '', { emitEvent: false });
        } catch (error) {
            console.error(error);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}

export interface OrderHeadCustomerFormGroup {
    stat_cust_no: FormControl<string>;
    stat_cust_name: FormControl<string>;
    stat_cust_address: FormControl<string>;
    contact_pers_no: FormControl<string>;
    customers_orderno: FormControl<string>;
    svea_payment_uri: FormControl<string>;
    project_keyno: FormControl<string>;
    project_name: FormControl<string>;
    serviceobject_keyno: FormControl<string>;
    serviceobject_name: FormControl<string>;
    customers_ref1: FormControl<string>;
    customers_ref2: FormControl<string>;
    message_from_sales: FormControl<string>;
    message_to_supplier: FormControl<string>;
    label: FormControl<string>;
    stat_business_id: FormControl<string>;
    stat_coop_id: FormControl<string>;
}

export interface OrderHeadDeliveryFormGroup {
    delivery_cust_unreg: FormControl<string>;
    delivery_cust_no: FormControl<string>;
    delivery_cust_name: FormControl<string>;
    delivery_cust_address: FormControl<string>;
    delivery_adr_street: FormControl<string>;
    delivery_postplace_id_street: FormControl<string>;
    delivery_postplace_id_and_name_street: FormControl<string>;
    delivery_adr_mail: FormControl<string>;
    delivery_postplace_name: FormControl<string>;
    delivery_postplace_name_street: FormControl<string>;
    delivery_postplace_id: FormControl<string>;
    delivery_postplace_id_and_name: FormControl<string>;
    delivery_country_id: FormControl<string>;
    delivery_place: FormControl<string>;
    delivery_cust_phone: FormControl<string>;
    delivery_email: FormControl<string>;
    deladronpurch: FormControl<string>;
    delivery_adr_note: FormControl<string>;
    delivery_business_id: FormControl<string>;
    delivery_coop_id: FormControl<string>;
    offer_valid_to_date: FormControl<string>;
    offer_sent: FormControl<string>;
    deliverydate_wish: FormControl<string>;
    deliverydate_text: FormControl<string>;
    deliverydate_confirmed: FormControl<string>;
    deliverytime_confirmed: FormControl<string>;
    deliverymethod_no: FormControl<string>;
    pickjobgrp_keyno: FormControl<string>;
    partly_delivery_allowed: FormControl<string>;
    printed_orderconfirm: FormControl<string>;
}

export interface OrderHeadInvoiceFormGroup {
    invoice_cust_no: FormControl<string>;
    invoice_cust_name: FormControl<string>;
    invoice_cust_address: FormControl<string>;
    invoice_country_id: FormControl<string>;
    invoice_business_id: FormControl<string>;
    invoice_coop_id: FormControl<string>;
    deliveryterm_no: FormControl<string>;
    freight_paid_by: FormControl<string>;
    freight_cost_ordval: FormControl<string | number>;
    freight_cost_ordval_agreed: FormControl<string | number>;
    custbonusdeal: FormControl<string>;
    carriers_paid_by_customer: FormControl<string>;
    payment_id: FormControl<string>;
    factoring_no: FormControl<string>;
    pricelist_id: FormControl<string>;
    pricelist_id2: FormControl<string>;
    purchase_pricelist_id: FormControl<string>;
    purchase_pricelist_id2: FormControl<string>;
    tax_keyno: FormControl<string>;
    invoicemethod_no: FormControl<string>;
    order_valuta_id: FormControl<string>;
    invoice_valuta_id: FormControl<string>;
    special_discount2_keyno: FormControl<string>;
    collection_keyno: FormControl<string>;
}
